"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.readableStudyIpAccountabilityBySubjectType = exports.readableStudyDigestVerificationStatus = exports.readableStudyDigestHashingStatus = exports.readableStudyDigestType = exports.readableStudyIpReturnStatus = exports.readableStudyIpCodeDisableReason = exports.readableStudyIpInfoType = exports.readableStudyIpDeliveryStatus = exports.readableStudyQueryUploadDetailStatus = exports.readableStudyQueryUploadApplyStatus = exports.readableStudyQueryUploadValidateStatus = exports.readableStudyQueryUploadDetailApplyStatus = exports.readableStudyQueryUploadDetailValidateStatus = exports.offsetToTimezone = exports.readableNotificationStatus = exports.readableStudyRandomizationUploadStatus = exports.readableStudyRoleUploadStatus = exports.readableStudyUatVerbStatus = exports.readableStudyUatStatus = exports.readableStudyUatCategory = exports.readableInquiryCategory = exports.readableInquiryType = exports.readableStudyReportStatus = exports.readableVisitName = exports.readableCrfFolderType = exports.readableLabelObject = exports.readableStudySubjectSex = exports.readableStudySubjectSigningStatus = exports.readableStudyCaptureSummaryStatus = exports.readableStudyQueryStatus = exports.readableStudyQueryType = exports.readableStudySubjectStatus = exports.readableStudyStatus = exports.convertAffiliationTypeToUrlString = exports.readableAffiliationType = exports.readableFaqCategory = exports.readableSubjectBlindAction = exports.readableSubjectSigningStatus = exports.readableEcoaVisitStatus = exports.readableRefAuditReason = exports.readableLang = void 0;
const common_1 = require("../consts/common");
const faq_1 = require("../consts/faq");
const resource_1 = require("../consts/resource");
const entity_1 = require("../dto/entity");
const affiliation_1 = require("../dto/entity/affiliation");
const studyCaptureSummaryStatus_1 = require("../dto/entity/common/studyCaptureSummaryStatus");
const ecoaVisit_1 = require("../dto/entity/ecoaVisit");
const inquiry_1 = require("../dto/entity/inquiry");
const study_1 = require("../dto/entity/study");
const studyDigest_1 = require("../dto/entity/studyDigest");
const studyIp_1 = require("../dto/entity/studyIp");
const studyQuery_1 = require("../dto/entity/studyQuery");
const studyRandomization_1 = require("../dto/entity/studyRandomization");
const studyReport_1 = require("../dto/entity/studyReport");
const studyRole_1 = require("../dto/entity/studyRole");
const studySubject_1 = require("../dto/entity/studySubject");
const studySubjectBlindAction_1 = require("../dto/entity/studySubjectBlindAction");
const studyUat_1 = require("../dto/entity/studyUat");
function readableLang(lang, defaultVal = "-") {
    switch (lang) {
        case common_1.LoLang.EN:
            return "English";
        case common_1.LoLang.KO:
            return "Korean";
        case common_1.LoLang.JA:
            return "Japanese";
        case common_1.LoLang.ZH:
            return "Chinese";
        default:
            return lang || defaultVal;
    }
}
exports.readableLang = readableLang;
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function readableRefAuditReason(reason, lang) {
    if (!reason || !reason.key) {
        return reason.typeText || "(Null)";
    }
    switch (reason.key) {
        case resource_1.RefAuditReasonKey.StudySubjectCreate:
            return "Subject 등록";
        case resource_1.RefAuditReasonKey.StudySubjectInitializationStatusUpdatedToProcessing:
            return "Subject 초기화 시작";
        case resource_1.RefAuditReasonKey.StudySubjectInitializationStatusUpdatedToProcessed:
            return "Subject 초기화 완료";
        case resource_1.RefAuditReasonKey.StudySubjectInitializationStatusUpdatedToFail:
            return "Subject 초기화 실패";
        case resource_1.RefAuditReasonKey.StudySubjectMigrate:
            return "Subject Migrate";
        case resource_1.RefAuditReasonKey.StudySubjectInit:
            return "Subject 초기화";
        case resource_1.RefAuditReasonKey.StudySubjectVisitAdd:
            return "Subject Visit 추가";
        case resource_1.RefAuditReasonKey.StudySubjectVisitRemove:
            return "Subject Visit 삭제";
        case resource_1.RefAuditReasonKey.StudySubjectVisitInit:
            return "Subject Visit 초기화";
        case resource_1.RefAuditReasonKey.StudySubjectSigningStatusChanged:
            return "전자서명 상태 변경";
        case resource_1.RefAuditReasonKey.StudySubjectSubjectNoUpdated:
            return "SubjectNo 변경";
        case resource_1.RefAuditReasonKey.StudySubjectAllocated:
            return "Subject Allocated";
        case resource_1.RefAuditReasonKey.StudySubjectRandomized:
            return "Subject Randomized";
        case resource_1.RefAuditReasonKey.StudySubjectAgeUpdated:
            return "Subject 나이 변경";
        case resource_1.RefAuditReasonKey.StudySubjectSexUpdated:
            return "Subject 성별 변경";
        case resource_1.RefAuditReasonKey.StudySubjectBirthDateUpdated:
            return "Subject 생일 변경";
        case resource_1.RefAuditReasonKey.StudySubjectIcfApprovedDateUpdated:
            return "Subject 동의서서명일 변경";
        case resource_1.RefAuditReasonKey.StudySubjectECoaAccessCodeUpdated:
            return "Subject eCOA Access Code 변경";
        case resource_1.RefAuditReasonKey.StudySubjectStatusUpdatedToRegistration:
            return "Subject Registration";
        case resource_1.RefAuditReasonKey.StudySubjectStatusUpdatedToEnrolled:
            return "Subject Enrolled";
        case resource_1.RefAuditReasonKey.StudySubjectStatusUpdatedToScreening:
            return "Subject Screening";
        case resource_1.RefAuditReasonKey.StudySubjectStatusUpdatedToScreeningFailed:
            return "Subject Screening Failed";
        case resource_1.RefAuditReasonKey.StudySubjectStatusUpdatedToOngoing:
            return "Subject Ongoing";
        case resource_1.RefAuditReasonKey.StudySubjectStatusUpdatedToDroppedOut:
            return "Subject Dropped Out";
        case resource_1.RefAuditReasonKey.StudySubjectStatusUpdatedToCompleted:
            return "Subject Completed";
        case resource_1.RefAuditReasonKey.StudySubjectVisitDateUpdated:
            return "Subject 방문 정보 변경";
        case resource_1.RefAuditReasonKey.StudySubjectReservedUpdated:
            return "Subject Reserved 정보 변경";
        case resource_1.RefAuditReasonKey.StudySubjectUnblindRequest:
            return "Subject Blind 해제 요청";
        case resource_1.RefAuditReasonKey.StudySubjectUnblindApprove:
            return "Subject Blind 해제 승인";
        case resource_1.RefAuditReasonKey.StudySubjectUnblindForce:
            return "Subject Blind 해제 (Force)";
        case resource_1.RefAuditReasonKey.StudySubjectUnblindForceUnderConds:
            return "Subject Blind 해제 (명시된 조건 만족)";
        case resource_1.RefAuditReasonKey.StudySubjectTriggerInvokeAllExplicitly:
            return "Subject 전체 Trigger 재수행";
        case resource_1.RefAuditReasonKey.StudySubjectCrfRefresh:
            return "Subject CRF Refresh";
        default:
            return reason.key || "(Unknown)";
    }
}
exports.readableRefAuditReason = readableRefAuditReason;
function readableEcoaVisitStatus(status, lang, defaultVal = "Unknown") {
    switch (status) {
        case ecoaVisit_1.EcoaVisitStatus.Done:
            return "완료";
        case ecoaVisit_1.EcoaVisitStatus.NotAvailable:
            return "입력불가";
        case ecoaVisit_1.EcoaVisitStatus.NotDone:
            return "미완료";
        case ecoaVisit_1.EcoaVisitStatus.Ongoing:
            return "진행중";
        default:
            return status || defaultVal;
    }
}
exports.readableEcoaVisitStatus = readableEcoaVisitStatus;
function readableSubjectSigningStatus(status, lang, defaultVal = "Unknown") {
    switch (status) {
        case studySubject_1.StudySubjectSigningStatus.Incomplete:
            return "미완료";
        case studySubject_1.StudySubjectSigningStatus.PartiallyCompleted:
            return "부분완료";
        case studySubject_1.StudySubjectSigningStatus.Completed:
            return "완료";
        default:
            return status || defaultVal;
    }
}
exports.readableSubjectSigningStatus = readableSubjectSigningStatus;
function readableSubjectBlindAction(action, lang, defaultVal = "Unknown") {
    switch (action) {
        case studySubjectBlindAction_1.StudySubjectBlindActionType.UnblindRequest:
            return "눈가림 해제 요청";
        case studySubjectBlindAction_1.StudySubjectBlindActionType.UnblindApprove:
            return "눈가림 해제 승인";
        case studySubjectBlindAction_1.StudySubjectBlindActionType.UnblindForce:
            return "강제 눈가림 해제";
        case studySubjectBlindAction_1.StudySubjectBlindActionType.UnblindForceUnderConds:
            return "눈가림 해제 (명시된 조건 만족)";
        default:
            return action || defaultVal;
    }
}
exports.readableSubjectBlindAction = readableSubjectBlindAction;
function readableFaqCategory(category, defaultVal = "-") {
    switch (category) {
        case faq_1.FaqCategory.EDC:
            return "EDC";
        case faq_1.FaqCategory.STUDY:
            return "Study";
        default:
            return category || defaultVal;
    }
}
exports.readableFaqCategory = readableFaqCategory;
function readableAffiliationType(affiliationType, defaultVal = "-") {
    switch (affiliationType) {
        case affiliation_1.AffiliationType.Cro:
            return "CRO";
        case affiliation_1.AffiliationType.Site:
            return "Site";
        case affiliation_1.AffiliationType.Sponsor:
            return "Sponsor";
        case affiliation_1.AffiliationType.System:
            return "System";
        default:
            return affiliationType || defaultVal;
    }
}
exports.readableAffiliationType = readableAffiliationType;
function convertAffiliationTypeToUrlString(affiliationType, defaultVal = "-") {
    switch (affiliationType) {
        case affiliation_1.AffiliationType.Cro:
            return "cros";
        case affiliation_1.AffiliationType.Site:
            return "sites";
        case affiliation_1.AffiliationType.Sponsor:
            return "sponsors";
        default:
            return affiliationType || defaultVal;
    }
}
exports.convertAffiliationTypeToUrlString = convertAffiliationTypeToUrlString;
function readableStudyStatus(status, defaultVal = "-") {
    switch (status) {
        case study_1.StudyStatus.Wait:
            return "Wait";
        case study_1.StudyStatus.Ongoing:
            return "Ongoing";
        case study_1.StudyStatus.Closed:
            return "Closed";
        default:
            return status || defaultVal;
    }
}
exports.readableStudyStatus = readableStudyStatus;
function readableStudySubjectStatus(status, lang = common_1.LoLang.KO, defaultVal = "-") {
    if (lang === "KO") {
        switch (status) {
            case studySubject_1.StudySubjectStatus.Enrolled:
                return "등록";
            case studySubject_1.StudySubjectStatus.Screening:
                return "스크리닝";
            case studySubject_1.StudySubjectStatus.ScreeningFailed:
                return "스크리닝 탈락";
            case studySubject_1.StudySubjectStatus.Ongoing:
                return "진행 중";
            case studySubject_1.StudySubjectStatus.DroppedOut:
                return "중도탈락";
            case studySubject_1.StudySubjectStatus.Completed:
                return "완료";
            case studySubject_1.StudySubjectStatus.NotAvailable:
                return "N/A";
            case studySubject_1.StudySubjectStatus.Registering:
                return "등록 중";
            case studySubject_1.StudySubjectStatus.Registration:
                return "접수";
            default:
                return status || defaultVal;
        }
    }
    else if (lang === "EN") {
        switch (status) {
            case studySubject_1.StudySubjectStatus.Enrolled:
                return "Enroll";
            case studySubject_1.StudySubjectStatus.Screening:
                return "Screening";
            case studySubject_1.StudySubjectStatus.ScreeningFailed:
                return "Screening Failed";
            case studySubject_1.StudySubjectStatus.Ongoing:
                return "Ongoing";
            case studySubject_1.StudySubjectStatus.DroppedOut:
                return "Dropped Out";
            case studySubject_1.StudySubjectStatus.Completed:
                return "Completed";
            case studySubject_1.StudySubjectStatus.NotAvailable:
                return "N/A";
            case studySubject_1.StudySubjectStatus.Registering:
                return "Registering";
            case studySubject_1.StudySubjectStatus.Registration:
                return "Registration";
            default:
                return status || defaultVal;
        }
    }
    else {
        switch (status) {
            case studySubject_1.StudySubjectStatus.Enrolled:
                return "등록 (Enroll)";
            case studySubject_1.StudySubjectStatus.Screening:
                return "스크리닝 (Screening)";
            case studySubject_1.StudySubjectStatus.ScreeningFailed:
                return "스크리닝 탈락 (Screening Failed)";
            case studySubject_1.StudySubjectStatus.Ongoing:
                return "진행 중 (Ongoing)";
            case studySubject_1.StudySubjectStatus.DroppedOut:
                return "중도탈락 (Dropped Out)";
            case studySubject_1.StudySubjectStatus.Completed:
                return "완료 (Completed)";
            case studySubject_1.StudySubjectStatus.NotAvailable:
                return "N/A (Not Available)";
            case studySubject_1.StudySubjectStatus.Registering:
                return "등록 중 (Registering)";
            case studySubject_1.StudySubjectStatus.Registration:
                return "접수 (Registration)";
            default:
                return status || defaultVal;
        }
    }
}
exports.readableStudySubjectStatus = readableStudySubjectStatus;
function readableStudyQueryType(status, defaultVal = "-") {
    switch (status) {
        case studyQuery_1.StudyQueryType.Auto:
            return "Auto";
        case studyQuery_1.StudyQueryType.Manual:
            return "Manual";
        default:
            return status || defaultVal;
    }
}
exports.readableStudyQueryType = readableStudyQueryType;
function readableStudyQueryStatus(status, defaultVal = "-") {
    switch (status) {
        case studyQuery_1.StudyQueryStatus.Open:
            return "Open";
        case studyQuery_1.StudyQueryStatus.Resolving:
            return "Resolving";
        case studyQuery_1.StudyQueryStatus.Cancelled:
        case studyQuery_1.StudyQueryStatus.ForceCancelled:
        case studyQuery_1.StudyQueryStatus.Resolved:
        case studyQuery_1.StudyQueryStatus.ForceResolved:
        case studyQuery_1.StudyQueryStatus.Claimed:
        case studyQuery_1.StudyQueryStatus.ForceClaimed:
        case studyQuery_1.StudyQueryStatus.AutoClosed:
            return "Closed";
        case studyQuery_1.StudyQueryStatus.Pending:
            return "Pending";
        default:
            return status || defaultVal;
    }
}
exports.readableStudyQueryStatus = readableStudyQueryStatus;
function readableStudyCaptureSummaryStatus(status, defaultVal = "-") {
    switch (status) {
        case studyCaptureSummaryStatus_1.StudyCaptureSummaryStatus.NotAvailable:
            return "N/A";
        case studyCaptureSummaryStatus_1.StudyCaptureSummaryStatus.InComplete:
            return "미완료";
        case studyCaptureSummaryStatus_1.StudyCaptureSummaryStatus.PartiallyCompleted:
            return "부분완료";
        case studyCaptureSummaryStatus_1.StudyCaptureSummaryStatus.Completed:
            return "완료";
        default:
            return status || defaultVal;
    }
}
exports.readableStudyCaptureSummaryStatus = readableStudyCaptureSummaryStatus;
function readableStudySubjectSigningStatus(signingStatus, lang = common_1.LoLang.KO, defaultVal = "-") {
    if (lang === "KO") {
        switch (signingStatus) {
            case studySubject_1.StudySubjectSigningStatus.Completed:
                return "완료";
            case studySubject_1.StudySubjectSigningStatus.Incomplete:
                return "미완료";
            case studySubject_1.StudySubjectSigningStatus.PartiallyCompleted:
                return "부분완료";
            default:
                return signingStatus || defaultVal;
        }
    }
    else if (lang === "EN") {
        switch (signingStatus) {
            case studySubject_1.StudySubjectSigningStatus.Completed:
                return "Completed";
            case studySubject_1.StudySubjectSigningStatus.Incomplete:
                return "InCompleted";
            case studySubject_1.StudySubjectSigningStatus.PartiallyCompleted:
                return "Partially Completed";
            default:
                return signingStatus || defaultVal;
        }
    }
    else {
        switch (signingStatus) {
            case studySubject_1.StudySubjectSigningStatus.Completed:
                return "완료 (Completed)";
            case studySubject_1.StudySubjectSigningStatus.Incomplete:
                return "미완료 (InCompleted)";
            case studySubject_1.StudySubjectSigningStatus.PartiallyCompleted:
                return "부분완료 (Partially Completed)";
            default:
                return signingStatus || defaultVal;
        }
    }
}
exports.readableStudySubjectSigningStatus = readableStudySubjectSigningStatus;
function readableStudySubjectSex(sex, lang) {
    if (!sex)
        return null;
    if (lang === "KO") {
        return (sex === null || sex === void 0 ? void 0 : sex.ko) || "";
    }
    else if (lang === "EN") {
        return `${sex.en}`;
    }
    else {
        return `${sex === null || sex === void 0 ? void 0 : sex.ko} (${sex.en})`;
    }
}
exports.readableStudySubjectSex = readableStudySubjectSex;
function readableLabelObject(label, val) {
    return `${(label === null || label === void 0 ? void 0 : label.prefix) || ""}${String(val).padStart((label === null || label === void 0 ? void 0 : label.minlen) || 0, "0")}${(label === null || label === void 0 ? void 0 : label.suffix) || ""}`;
}
exports.readableLabelObject = readableLabelObject;
function readableCrfFolderType(folderType, defaultVal = "-") {
    switch (folderType) {
        case "NORMAL_VISIT":
            return "Normal Visit";
        case "ALL_VISIT":
            return "All Visit";
        case "UNSCHEDULED_VISIT":
            return "Unscheduled Visit";
        case "REPORT_SAE":
            return "SAE Report";
        case "REPORT_AE":
            return "AE Report";
        default:
            return folderType || defaultVal;
    }
}
exports.readableCrfFolderType = readableCrfFolderType;
function readableVisitName(visitId, visitSeq, studySpec) {
    const found = studySpec.folders
        .map(folder => {
        return folder.visits.find(visit => visit.id === visitId);
    })
        .find(e => typeof e === "object");
    if (typeof (found === null || found === void 0 ? void 0 : found.label) === "object") {
        return readableLabelObject(found.label, visitSeq);
    }
    return visitId;
}
exports.readableVisitName = readableVisitName;
function readableStudyReportStatus(status, sequence, defaultVal = "-") {
    switch (status) {
        case studyReport_1.StudyReportStatus.Initial:
            return "Initial";
        case studyReport_1.StudyReportStatus.InitialCapture:
            return "Initial Capture";
        case studyReport_1.StudyReportStatus.InitialSubmission:
            return "Initial Submission";
        case studyReport_1.StudyReportStatus.FollowUpCapture:
            return `FollowUp #${sequence} Capture`;
        case studyReport_1.StudyReportStatus.FollowUpSubmission:
            return `FollowUp #${sequence} Submission`;
        default:
            return status || defaultVal;
    }
}
exports.readableStudyReportStatus = readableStudyReportStatus;
function readableInquiryType(type, defaultVal = "-") {
    switch (type) {
        case inquiry_1.InquiryType.study:
            return "Study 관련 질의";
        case inquiry_1.InquiryType.system:
            return "System 관련 질의";
        default:
            return type || defaultVal;
    }
}
exports.readableInquiryType = readableInquiryType;
function readableInquiryCategory(category, defaultVal = "-") {
    switch (category) {
        case inquiry_1.InquiryCategory.sponsor:
            return "신규 Sponsor 등록 및 Sponsor 정보 변경 문의";
        case inquiry_1.InquiryCategory.cro:
            return "신규 CRO 등록 및 CRO 정보 변경 문의";
        case inquiry_1.InquiryCategory.site:
            return "신규 Site 등록 및 Site 정보 변경 문의";
        case inquiry_1.InquiryCategory.account:
            return "계정 관련 문의";
        case inquiry_1.InquiryCategory.study:
            return "Study 관련 문의";
        case inquiry_1.InquiryCategory.edc:
            return "EDC 사용 관련 문의";
        case inquiry_1.InquiryCategory.etc:
            return "기타 문의";
        default:
            return category || defaultVal;
    }
}
exports.readableInquiryCategory = readableInquiryCategory;
function readableStudyUatCategory(category, defaultVal = "-") {
    switch (category) {
        case studyUat_1.StudyUatCategory.EntryScreen:
            return "Entry Screen";
        case studyUat_1.StudyUatCategory.Trigger:
            return "Trigger";
        case studyUat_1.StudyUatCategory.Role:
            return "Role";
        case studyUat_1.StudyUatCategory.Privilege:
            return "Privilege";
        case studyUat_1.StudyUatCategory.Other:
            return "Other";
        default:
            return category || defaultVal;
    }
}
exports.readableStudyUatCategory = readableStudyUatCategory;
function readableStudyUatStatus(status, defaultVal = "-") {
    switch (status) {
        case studyUat_1.StudyUatStatus.Submitted:
            return "Submitted";
        case studyUat_1.StudyUatStatus.Accepted:
            return "Accepted";
        case studyUat_1.StudyUatStatus.Applied:
            return "Applied";
        case studyUat_1.StudyUatStatus.Completed:
            return "Completed";
        case studyUat_1.StudyUatStatus.Cancelled:
            return "Canceled";
        default:
            return status || defaultVal;
    }
}
exports.readableStudyUatStatus = readableStudyUatStatus;
function readableStudyUatVerbStatus(status, defaultVal = "-") {
    switch (status) {
        case studyUat_1.StudyUatStatus.Accepted:
            return "Accept";
        case studyUat_1.StudyUatStatus.Applied:
            return "Change to Applied";
        case studyUat_1.StudyUatStatus.Completed:
            return "Change to Completed";
        case studyUat_1.StudyUatStatus.Cancelled:
            return "Cancel";
        default:
            return readableStudyUatStatus(status, defaultVal);
    }
}
exports.readableStudyUatVerbStatus = readableStudyUatVerbStatus;
function readableStudyRoleUploadStatus(status, defaultVal = "-") {
    switch (status) {
        case studyRole_1.StudyRoleUploadStatus.Wait:
            return "Wait";
        case studyRole_1.StudyRoleUploadStatus.Processing:
            return "Processing";
        case studyRole_1.StudyRoleUploadStatus.Processed:
            return "Processed";
        case studyRole_1.StudyRoleUploadStatus.Failed:
            return "Failed";
        default:
            return status || defaultVal;
    }
}
exports.readableStudyRoleUploadStatus = readableStudyRoleUploadStatus;
function readableStudyRandomizationUploadStatus(status, defaultVal = "-") {
    switch (status) {
        case studyRandomization_1.StudyRandomizationUploadStatus.Wait:
            return "Wait";
        case studyRandomization_1.StudyRandomizationUploadStatus.Processing:
            return "Processing";
        case studyRandomization_1.StudyRandomizationUploadStatus.Processed:
            return "Processed";
        case studyRandomization_1.StudyRandomizationUploadStatus.Failed:
            return "Failed";
        default:
            return status || defaultVal;
    }
}
exports.readableStudyRandomizationUploadStatus = readableStudyRandomizationUploadStatus;
function readableNotificationStatus(notificationStatus, notificationQueueStatus, defaultVal = "-") {
    switch (notificationQueueStatus) {
        case entity_1.NotificationQueueStatus.Sent:
            return "Sent";
        case entity_1.NotificationQueueStatus.Sending:
            return "Sending ..";
        case entity_1.NotificationQueueStatus.Failed:
            return "Failed";
        case entity_1.NotificationQueueStatus.Wait:
        default:
            switch (notificationStatus) {
                case entity_1.NotificationStatus.Wait:
                    return "Wait";
                case entity_1.NotificationStatus.Preparing:
                    return "Preparing ..";
                case entity_1.NotificationStatus.Prepared:
                    return "Prepared";
                case entity_1.NotificationStatus.Done:
                    return "Done";
                case entity_1.NotificationStatus.Broken:
                    return "Error";
                case entity_1.NotificationStatus.Failed:
                    return "Failed";
                default:
                    return notificationQueueStatus || notificationStatus || defaultVal;
            }
    }
}
exports.readableNotificationStatus = readableNotificationStatus;
function offsetToTimezone(offset) {
    const absOffset = offset < 0 ? offset * -1 : offset;
    const sign = offset < 0 ? "-" : "+";
    const hh = String(Math.floor(absOffset / 60)).padStart(2, "0");
    const mm = String(absOffset % 60).padStart(2, "0");
    return `${sign}${hh}:${mm}`;
}
exports.offsetToTimezone = offsetToTimezone;
function readableStudyQueryUploadDetailValidateStatus(status, defaultVal = "-") {
    switch (status) {
        case studyQuery_1.StudyQueryUploadDetailValidateStatus.Wait:
            return "Wait";
        case studyQuery_1.StudyQueryUploadDetailValidateStatus.Processing:
            return "Processing";
        case studyQuery_1.StudyQueryUploadDetailValidateStatus.Succeed:
            return "Succeed";
        case studyQuery_1.StudyQueryUploadDetailValidateStatus.Failed:
            return "Failed";
        default:
            return status || defaultVal;
    }
}
exports.readableStudyQueryUploadDetailValidateStatus = readableStudyQueryUploadDetailValidateStatus;
function readableStudyQueryUploadDetailApplyStatus(status, defaultVal = "-") {
    switch (status) {
        case studyQuery_1.StudyQueryUploadDetailApplyStatus.None:
            return "None";
        case studyQuery_1.StudyQueryUploadDetailApplyStatus.Wait:
            return "Wait";
        case studyQuery_1.StudyQueryUploadDetailApplyStatus.Processing:
            return "Processing";
        case studyQuery_1.StudyQueryUploadDetailApplyStatus.Succeed:
            return "Succeed";
        case studyQuery_1.StudyQueryUploadDetailApplyStatus.Failed:
            return "Failed";
        default:
            return status || defaultVal;
    }
}
exports.readableStudyQueryUploadDetailApplyStatus = readableStudyQueryUploadDetailApplyStatus;
function readableStudyQueryUploadValidateStatus(status, defaultVal = "-") {
    switch (status) {
        case studyQuery_1.StudyQueryUploadValidateStatus.Wait:
            return "Wait";
        case studyQuery_1.StudyQueryUploadValidateStatus.Processing:
            return "Processing";
        case studyQuery_1.StudyQueryUploadValidateStatus.PartiallySucceed:
            return "Partially Succeed";
        case studyQuery_1.StudyQueryUploadValidateStatus.Succeed:
            return "All Succeed";
        case studyQuery_1.StudyQueryUploadValidateStatus.Failed:
            return "Failed";
        default:
            return status || defaultVal;
    }
}
exports.readableStudyQueryUploadValidateStatus = readableStudyQueryUploadValidateStatus;
function readableStudyQueryUploadApplyStatus(status, defaultVal = "-") {
    switch (status) {
        case studyQuery_1.StudyQueryUploadApplyStatus.None:
            return "None";
        case studyQuery_1.StudyQueryUploadApplyStatus.Wait:
            return "Wait";
        case studyQuery_1.StudyQueryUploadApplyStatus.Processing:
            return "Processing";
        case studyQuery_1.StudyQueryUploadApplyStatus.PartiallySucceed:
            return "Partially Succeed";
        case studyQuery_1.StudyQueryUploadApplyStatus.Succeed:
            return "All Succeed";
        case studyQuery_1.StudyQueryUploadApplyStatus.Failed:
            return "Failed";
        default:
            return status || defaultVal;
    }
}
exports.readableStudyQueryUploadApplyStatus = readableStudyQueryUploadApplyStatus;
function readableStudyQueryUploadDetailStatus(status, defaultVal = "-") {
    switch (status) {
        case studyQuery_1.StudyQueryUploadDetailStatus.Open:
            return "Open";
        case studyQuery_1.StudyQueryUploadDetailStatus.InvalidData:
            return "Invalid Data";
        default:
            return status || defaultVal;
    }
}
exports.readableStudyQueryUploadDetailStatus = readableStudyQueryUploadDetailStatus;
function readableStudyIpDeliveryStatus(status, defaultVal = "-") {
    switch (status) {
        case studyIp_1.StudyIpDeliveryStatus.AutoRequested:
            return "Auto Requested";
        case studyIp_1.StudyIpDeliveryStatus.Requested:
            return "Requested";
        case studyIp_1.StudyIpDeliveryStatus.Approved:
            return "Approved";
        case studyIp_1.StudyIpDeliveryStatus.Started:
            return "On Delivery";
        case studyIp_1.StudyIpDeliveryStatus.Delivered:
            return "Delivered";
        case studyIp_1.StudyIpDeliveryStatus.Canceled:
            return "Canceled";
        default:
            return status || defaultVal;
    }
}
exports.readableStudyIpDeliveryStatus = readableStudyIpDeliveryStatus;
function readableStudyIpInfoType(status, defaultVal = "-") {
    switch (status) {
        case studyIp_1.StudyIpInfoType.RunIn:
            return "Run In";
        case studyIp_1.StudyIpInfoType.Treatment:
            return "Treatment";
        default:
            return status || defaultVal;
    }
}
exports.readableStudyIpInfoType = readableStudyIpInfoType;
function readableStudyIpCodeDisableReason(status, lang, defaultVal = "-") {
    switch (status) {
        case studyIp_1.StudyIpCodeDisableReason.DeliveryDamaged:
            return "배송파손";
        case studyIp_1.StudyIpCodeDisableReason.DeliveryLoss:
            return "배송분실";
        case studyIp_1.StudyIpCodeDisableReason.DeliveryOmit:
            return "배송누락";
        case studyIp_1.StudyIpCodeDisableReason.Damaged:
            return "파손";
        case studyIp_1.StudyIpCodeDisableReason.Loss:
            return "분실";
        case studyIp_1.StudyIpCodeDisableReason.Misdispense:
            return "오불출";
        case studyIp_1.StudyIpCodeDisableReason.Unused:
            return "미사용";
        default:
            return status || defaultVal;
    }
}
exports.readableStudyIpCodeDisableReason = readableStudyIpCodeDisableReason;
function readableStudyIpReturnStatus(status, lang, defaultVal = "-") {
    switch (status) {
        case studyIp_1.StudyIpReturnStatus.Requested:
            return "반납 요청";
        case studyIp_1.StudyIpReturnStatus.Returned:
            return "반납 완료";
        case studyIp_1.StudyIpReturnStatus.Canceled:
            return "반납 취소";
        default:
            return status || defaultVal;
    }
}
exports.readableStudyIpReturnStatus = readableStudyIpReturnStatus;
function readableStudyDigestType(status, defaultVal = "-") {
    switch (status) {
        case studyDigest_1.StudyDigestType.Capture:
            return "Data Capture";
        case studyDigest_1.StudyDigestType.QueryMessage:
            return "Query Message";
        case studyDigest_1.StudyDigestType.QueryStatus:
            return "Query Status";
        default:
            return status || defaultVal;
    }
}
exports.readableStudyDigestType = readableStudyDigestType;
function readableStudyDigestHashingStatus(status, defaultVal = "-") {
    switch (status) {
        case studyDigest_1.StudyDigestHashingStatus.Wait:
            return "Wait";
        case studyDigest_1.StudyDigestHashingStatus.Processing:
            return "Processing";
        case studyDigest_1.StudyDigestHashingStatus.Done:
            return "Done";
        case studyDigest_1.StudyDigestHashingStatus.Failed:
            return "Failed";
        default:
            return status || defaultVal;
    }
}
exports.readableStudyDigestHashingStatus = readableStudyDigestHashingStatus;
function readableStudyDigestVerificationStatus(status, defaultVal = "-") {
    switch (status) {
        case studyDigest_1.StudyDigestVerificationStatus.Wait:
            return "Wait";
        case studyDigest_1.StudyDigestVerificationStatus.Valid:
            return "Valid";
        case studyDigest_1.StudyDigestVerificationStatus.Invalid:
            return "Invalid";
        default:
            return status || defaultVal;
    }
}
exports.readableStudyDigestVerificationStatus = readableStudyDigestVerificationStatus;
function readableStudyIpAccountabilityBySubjectType(type, defaultVal = "-") {
    switch (type) {
        case studyIp_1.StudyIpAccountabilityBySubjectType.Dispense:
            return "Dispense";
        case studyIp_1.StudyIpAccountabilityBySubjectType.Return:
            return "Return";
        default:
            return type || defaultVal;
    }
}
exports.readableStudyIpAccountabilityBySubjectType = readableStudyIpAccountabilityBySubjectType;
//# sourceMappingURL=converter.js.map